module.exports = __webpack_public_path__ + "img/sidebar-logo.1c035867.png";